import _ from 'lodash';
import { connect } from 'react-redux';
import { Component } from 'react';

export type TSiteMetaProps = {
  auth: any;
  siteMeta: any;
  siteConfig: any;
  currentFeatures: any;
};

// imports core site state from the store and passes it as props to child
class SiteMetaWrapperBase extends Component<any, any> {
  public render() {
    return (
      <this.props.component
        {...this.props.componentProps}
        {...(this.props.pick ? _.pick(this.props.siteMeta, this.props.pick) : this.props.siteMeta)}
      />
    );
  }
}

function mapStateToProps(state: any) {
  return {
    siteMeta: {
      auth: state.auth,
      siteMeta: state.siteMeta,
      siteConfig: state.siteConfig,
      currentFeatures: state.currentFeatures
    }
  };
}

const SiteMetaWrapper = connect<any, any, any>(mapStateToProps)(SiteMetaWrapperBase);

// HOC to return the wrapped component but pass in site meta as props to it
export const withSiteMeta = (WrappedComponent: any, pick?: string[]) => {
  return class extends Component<any, any> {
    public static async serverPreloadActions(...args: any[]) {
      if (WrappedComponent.serverPreloadActions) {
        return WrappedComponent.serverPreloadActions(...args);
      }
      return [];
    }

    public render() {
      return <SiteMetaWrapper component={WrappedComponent} componentProps={this.props} pick={pick} />;
    }
  };
};
